import styled from 'styled-components'

import { color } from '../../styles'

import { fontSize, fontWeight } from 'src/styles/fonts'

export const Wrap = styled.div`
  margin: 7rem 6rem 3rem;
`

export const TopSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${color.WHITE};
  border-top-left-radius: 1.6rem;
  border-top-right-radius: 1.6rem;
  margin-bottom: 5.6rem;
  width: 100%;
`

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 3.2rem 0;

  button {
    margin-bottom: 0.8rem;
  }
`

export const DownloadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${color.VERY_LIGHT_PINK};
  padding: 3.2rem 0;
  border-bottom-left-radius: 1.6rem;
  border-bottom-right-radius: 1.6rem;
`

export const AppStoreButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12.4rem;
  height: 5.6rem;
  border-radius: 2.8rem;
  box-shadow: 0 1rem 1rem 0 rgba(0, 0, 0, 0.04);
  background-color: ${color.WHITE};
`

export const Title = styled.h3`
  font-size: ${fontSize.LARGE_XXL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.33;
  text-align: center;
  color: ${color.GREYISH_BROWN};
  margin: 0 0 0.4rem;
`
